import React from 'react';
import CompanyChannel from './CompanyChannel';

export default function ChannelStack() {
  return (
    <>
      <CompanyChannel />
    </>
  );
}
